import { Component, OnInit } from '@angular/core';
import {CreateCardService} from '../../services/create-card.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CreateCardBatchItem, CreateCardItem} from '../../../models/create-card/create-card';
import {ContentRowField} from '../../../shared/content-row/content-row.component';
import {AppUser} from '../../../dto/app-user';
import {RevolutTransactionLeg} from '../../../dto/revolut-transaction-leg';
import {formatNumber} from '@angular/common';
import {CardsService} from '../../services/cards.service';
import {ToastService} from 'angular-toastify';
import {CardCreationImportService} from '../../services/card-creation-import.service';
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'app-card-creations-detail',
  templateUrl: './card-creations-detail.component.html',
  styleUrls: ['./card-creations-detail.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class CardCreationsDetailComponent implements OnInit {

  dataSource = [];

  columns = [
    { columnDef: 'name', header: 'Name', cell: row => `${row.firstName} ${row.lastName}`, sortable: true },
    { columnDef: 'product', header: 'ProductID', cell: row => row.cclProductId, sortable: true },
    { columnDef: 'token', header: 'Token', cell: row => row.cardToken, sortable: true },
    { columnDef: 'thermalLine1', header: 'Load Amt.', cell: row => row.thermalLine1, sortable: true },
    { columnDef: 'loadValue', header: 'Load Amt.', cell: row => row.loadValue, sortable: true },
    { columnDef: 'createType', header: 'Card Type', cell: row => this.getCreateTypeName(row.createType), sortable: true },
    { columnDef: 'externalRef', header: 'Ext.Ref.', cell: row => row.externalRef, sortable: true },
    { columnDef: 'design', header: 'Design', cell: row => row.cardDesign, sortable: true },
    { columnDef: 'status', header: 'Status', cell: row => row.status, sortable: true },
    { columnDef: 'msg', header: 'Message', cell: row => row.error, sortable: true },


  ] as ContentRowField<CreateCardItem>[];



  batch: CreateCardBatchItem;
  failedCards: CreateCardItem[] = [];

  isLoading = false;
  fields = [
    { header: 'PublicToken', cell: (row: CreateCardItem) => `${row.cardToken}` },
    { header: 'PrimaryToken', cell: (row: CreateCardItem) => `${row.primaryToken}` },
    { header: 'Card Name', cell: (row: CreateCardItem) => `${row.cardName}` },
    { header: 'ProductRef', cell: (row: CreateCardItem) => `${row.productRef}` },
    { header: 'CardDesign', cell: (row: CreateCardItem) => `${row.cardDesign}` },
    { header: 'CreateType', cell: (row: CreateCardItem) => {
        if ( row.createType === 1 ) {
return 'Virtual';
}
        if ( row.createType === 2 ) {
return 'Physical';
}
        if ( row.createType === 3 ) {
return 'Initially Virtual';
}
        if ( row.createType === 4 ) {
return 'MVC';
}
      }},
    { header: 'First name', cell: (row: CreateCardItem) => `${row.firstName}` },
    { header: 'Last name', cell: (row: CreateCardItem) => `${row.lastName}` },
    { header: 'Phone', cell: (row: CreateCardItem) => `${row.mobile}` },
    { header: 'E-Mail', cell: (row: CreateCardItem) => `${row.email}` },
    { header: 'Address L1', cell: (row: CreateCardItem) => `${row.addrl1}` },
    { header: 'Address L2', cell: (row: CreateCardItem) => `${row.addrl2}` },
    { header: 'Address L3', cell: (row: CreateCardItem) => `${row.addrl3}` },
    { header: 'Post code', cell: (row: CreateCardItem) => `${row.postCode}` },
    { header: 'City', cell: (row: CreateCardItem) => `${row.city}` },
    { header: 'Load value', cell: (row: CreateCardItem) => `${row.loadValue}` },
    { header: 'Delivery Method', cell: (row: CreateCardItem) => `${row.deliveryMethod}` },
    { header: 'Delivery L1', cell: (row: CreateCardItem) => `${row.deliveryAddrl1}` },
    { header: 'Delivery L2', cell: (row: CreateCardItem) => `${row.deliveryAddrl2}` },
    { header: 'Delivery L3', cell: (row: CreateCardItem) => `${row.deliveryAddrl3}` },

  ] as ContentRowField<CreateCardItem>[];

  isExecutingBatch = false;
  pollInterval: ReturnType<typeof setTimeout>|null = null;
  batchId = 0;

  getCreateTypeName(createType: number) {
    if ( createType === 1 ) {
      return 'Virtual';
    }
    if ( createType === 2 ) {
      return 'Physical';
    }
    if ( createType === 3 ) {
      return 'Initially Virtual';
    }
    if ( createType === 4 ) {
      return 'MVC';
    }
    if ( createType === 900 ) {
      return 'Pseudo';
    }

    return "Unknown";
  }

  constructor(
    private createCardService: CreateCardService,
    private route: ActivatedRoute,
    private router: Router,
    private cardsService: CardsService,
    private _toastService: ToastService,

  ) { }

  ngOnInit(): void {
    this.batchId = parseInt(this.route.snapshot.paramMap.get('id'));
    this.loadData();

  }

  loadData() {
    this.isLoading = true;
    this.failedCards = [];
    this.createCardService.get(this.batchId).subscribe(data => {
      this.batch = data;
      this.dataSource = this.batch.cards;
      this.isLoading = false;
      this.failedCards = this.batch.cards.filter(c => c.status === 'FAILED');
    });
  }

  returnBack() {
    this.router.navigate(['..'], { relativeTo: this.route }).then();
  }

  executeBatch() {
    this.isExecutingBatch = true;
    const batchId = this.batch.id;
    this.cardsService.executeCreateCardBatch(this.batchId).subscribe(data => {

      this._toastService.info('Processing batch ' + batchId + '...');

      this.pollInterval = setInterval(() => this.pollBatch(batchId), 2000);

    }, err => {
      this._toastService.error(err.error.message || err.message || err.error || err);
    });

  }

  resetFailedBatch() {
    this.isExecutingBatch = true;
    const batchId = this.batch.id;
    this.cardsService.resetFailedCreateCardBatch(this.batchId).subscribe(data => {

      this._toastService.info('Resetting failed cards of batch ' + batchId + '...');

      this.pollInterval = setInterval(() => this.pollBatch(batchId), 2000);

    }, err => {
      this._toastService.error(err.error.message || err.message || err.error || err);
    });

  }

  private pollBatch(id: number) {

    this.createCardService.get(id).subscribe(b => {
      if ( !b.processing ) {
        clearInterval(this.pollInterval);
        this._toastService.success('Batch ' + id + ' was processed');
        this.loadData();
        this.isExecutingBatch = false;
        this.pollInterval = null;
      }


    });
  }

  importSuccessCards() {
    this.isExecutingBatch = true;
    const batchId = this.batch.id;
    this._toastService.info('Importing cards from batch ' + batchId + '...');
    this.cardsService.importSuccessCardsFromCardCreateBatch(batchId).subscribe(_ => {
      this._toastService.success('Imported cards from batch ' + batchId + '');
      this.isExecutingBatch = false;
      this.loadData();
    }, err => {
      this._toastService.error(err.error.message || err.message || err.error || err);
      this.isExecutingBatch = false;
    });
  }

}
